<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-download" @click="downloadTemplate"
          >下载模板
        </el-button>
        <el-button type="primary" icon="el-icon-upload2" @click="handleImport">导入数据 </el-button>
      </template>
    </avue-crud>
    <el-dialog title="便利店经营数据导入" append-to-body :visible.sync="excelBox" width="555px">
      <avue-form :option="excelOption" v-model="excelForm" :upload-after="uploadAfter">
        <template slot="excelTemplate"> </template>
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/demo/conveniencestore';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
export default {
  data() {
    return {
      excelBox: false,
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/v4ward/convenienceStore/upload',
          },
        ],
      },
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        searchLabelWidth: 100,
        labelWidth: 130,
        searchMenuSpan: 6,
        columnBtn: false,
        delBtn: false,
        editBtn: false,
        column: [
          {
            label: '便利店经营数据ID',
            prop: 'id',
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
          },
          {
            label: '便利店名称',
            prop: 'name',
            search: true,
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入便利店名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '便利店编号',
            prop: 'code',
            search: true,
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入便利店编号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '经营开始日期',
            prop: 'runStart',
            type: 'date',
            width: 100,
            format: 'yyyy-MM-dd',
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
          },
          {
            label: '经营结束日期',
            prop: 'runEnd',
            type: 'date',
            width: 100,
            format: 'yyyy-MM-dd',
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
          },
          // {
          //   label: '周期数',
          //   prop: 'billcycleNo',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入账单周期数',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          // {
          //   label: '经营周期',
          //   prop: 'operatingCycle',
          //   search: true,
          //   type: 'select',
          //   dataType: 'number',
          //   dicUrl: 'api/blade-system/dict/dictionary?code=operating_cycle',
          //   props: { label: 'dictValue', value: 'dictKey' },
          //   rules: [
          //     {
          //       required: true,
          //       message: '请选择经营周期',
          //       trigger: 'blur',
          //     },
          //   ],
          // },
          {
            label: '销售金额',
            prop: 'sellAmount',
            maxlength: 15,
            showWordLimit: true,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '能耗成本金额',
            prop: 'energyCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            width: 100,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '人员成本金额',
            prop: 'personnelCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            width: 100,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '房租成本金额',
            prop: 'rentCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            width: 100,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '货物成本金额',
            prop: 'commodityCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            width: 100,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '其他成本金额',
            prop: 'restsCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            width: 100,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '总成本金额',
            prop: 'sumCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            width: 100,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '盈利金额',
            prop: 'profitCostsAmount',
            maxlength: 15,
            showWordLimit: true,
            rules: [
              {
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入正确的数字，最多精确到小数点后2位',
              },
            ],
          },
          {
            label: '经营日期',
            prop: 'runRange',
            searchRange: true,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择经营日期',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上报时间',
            prop: 'createTime',
            type: 'date',
            width: 130,
            format: 'yyyy-MM-dd',
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
          },
          {
            label: '备注',
            prop: 'remark1',
            type: 'textarea',
            span: 24,
            row: 4,
            maxlength: 200,
          },
          {
            label: '上报时间',
            prop: 'createTimeRange',
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.conveniencestore_add, false),
        viewBtn: this.vaildData(this.permission.conveniencestore_view, false),
        delBtn: this.vaildData(this.permission.conveniencestore_delete, false),
        editBtn: this.vaildData(this.permission.conveniencestore_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    // 导入
    uploadAfter(res, done, loading, column) {
      this.excelBox = false;
      this.excelForm.excelFile = '';
      this.onLoad();
      done();
    },
    handleImport() {
      this.excelBox = true;
    },
    downloadTemplate() {
      window.open(`/api/v4ward/convenienceStore/downTemplate?Blade-Auth=${getToken()}`);
    },
    rowSave(row, loading, done) {
      row.runStart = row.runRange[0];
      row.runEnd = row.runRange[1];
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.runStart = row.runRange[0];
      row.runEnd = row.runRange[1];
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          let timeRange = [];
          timeRange.push(data.runStart);
          timeRange.push(data.runEnd);
          this.form.runRange = timeRange;
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      done();
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.createTimeRange) {
        this.query.createTimeStart = this.query.createTimeRange[0];
        this.query.createTimeEnd = this.query.createTimeRange[1];
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
